module.exports = __webpack_public_path__ + "static/media/player1.d5245908.png";